<div class="position-relative initials p-0 me-2">
    <div
        class="avatar rounded-circle d-flex"
        [ngClass]="['avatar-' + variant(), size()]"
        data-testid="avatar-circle"
    >
        @if (!hasIcon()) {
            <div [ngClass]="['text-' + variant()]" data-testid="avatar-text">
                {{ displayName() | initials }}
            </div>
        } @else if (hasIcon()) {
            <i
                [ngClass]="[icon(), 'text-' + variant()]"
                data-testid="avatar-icon"
            ></i>
        }
        @if (presenceClass()) {
            <span
                [ngClass]="[presenceClass(), size()]"
                class="position-absolute status-badge"
            ></span>
        }
    </div>
</div>
